import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'software-backlog-panel.epic.epic-panel.create-issue-button.label',
		defaultMessage: 'Create {issueTypeNameLowerCase}',
		description: `Accessibility label and also text of a button that will open a form to create an issue.
            It is also the tooltip when the button is in its compact form.
            The {issueTypeNameLowerCase} is a custom name for the issue type.`,
	},
});
